import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
    const token = JSON.parse(localStorage.getItem("clientToken"))
    return <Route {...rest} render={(props) => (token ? <Component {...props} /> : <Redirect to={{ pathname: "/", state: { referer: props.location } }} />)} />;
};

export default PrivateRoute;
